export class NewPasswordModel {
    userName: string;
    otp: string;
    otpUId: string;
    newPassword: string;
    oldPassword: string;
    emailOTP: string;
    roleId: number;
    languageCode: string;
    confirmPassword: string;
    display: boolean;
    header: string;
}

export class ValidUserResponseModel {
    customerUId: string;
    emailSendingError: string;
    isSentToEmail: boolean;
    isSentToMobile: boolean;
    sellerUId: string;
    smsSendingError: string;
    transactionUId: string;
    uId: string
}

export class OTPModel {
    uId: string;
    isSentToMobile: string;
    isSentToEmail: string;
    smsSendingError: string;
    emailSendingError: string;
    hasError: boolean;
    rowNo: number;
    error: string;
    errorTrace: string;
    recordAffected: number;
    entityUId: string;
    validationErrors: []
}